import React, {useContext} from "react";
import {
    ClientDetailDevicesHeaders,
    ClientDetailTransactionHeaders,
    ClientDetailUseContext
} from "./ClientDetailContext";
import Navbar from "../../components/main/Navbar";
import TitleDetail from "../../components/atoms/TitleDetail";
import InputGroup from "../../components/atoms/InputGroup";
import SubscriptionStatusComponent from "./components/SubscriptionStatusComponent";
import Table2 from "../../components/main/Table/Table2";
import ListsOperations from "../../tools/consts";
import log from "../../components/adminPage/Log";
import {showToastByIsSuccess} from "../../tools/tools";
import DeleteModal from "../../components/atoms/DeleteModal";
import UserSubscriptionDetail from "./components/UserSubscriptionDetail";

const ClientDetailScreen = () => {
    const {
        onDeviceDelete,
        onBrokerDelete,
        devicesList,
        transactionList,
        userBaseInfo,
        deleteDeviceCallback,
        deleteBrokerCallback,
        modalState,
        closeModal,
        loading
    } = ClientDetailUseContext();
    const token = localStorage.getItem("token");
    console.log("LOADING : ", loading)
    if (loading) {
        return;
    }
    return (
        <div className={"pb-7.5px"} dir={'rtl'}>
            <Navbar titles={["کاربر ها", "فهرست مشتریان", "جزئیات مشتری"]}/>
            <div className={"mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px"}>

                <TitleDetail title={"اطلاعات کلی"}/>
                <div className="flex flex-row justify-between w-full gap-5 mt-25">
                    <InputGroup
                        iconName={"profile-circle"}
                        label="نام کاربر"
                        value={userBaseInfo.fullName}
                        readOnly={true}
                    />
                    <InputGroup
                        iconName={"call"}
                        label="شماره تلفن"
                        value={userBaseInfo.phoneNumber.replace("+98", "0")}
                        readOnly={true}
                    />
                    <InputGroup
                        iconName={"location"}
                        label="استان و شهر"
                        value={userBaseInfo.location}
                    />

                </div>

                <div className="flex flex-row justify-between w-full gap-5 mt-25">
                    <InputGroup
                        iconName={"bubble"}
                        label="شغل"
                        value={userBaseInfo.job}
                        readOnly={true}
                    />
                    <InputGroup
                        iconName={"calendar"}
                        label="تاریخ ثبت نام"
                        value={userBaseInfo.registerDate}
                        readOnly={true}
                    />


                </div>

            </div>


            <UserSubscriptionDetail />

            <div
                className={"mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px "}>
                <TitleDetail title={"لیست دستگاه ها"} className={"mb-25"}/>

                <Table2
                    headers={ClientDetailDevicesHeaders}
                    tableData={devicesList}
                    operations={ListsOperations.getDeviceList(onDeviceDelete, onBrokerDelete, token)}
                    emptyText={"تاریخچه‌ای یافت نشد"}
                    heightEmptyState={'h-66'}
                    pageNumber={1}
                    limit={10}
                    hasOperation={true}
                />
                <DeleteModal
                    text={`آیا برای حذف “${modalState.selectedItem == null ? "" : modalState.selectedItem.serialNumber}” مطمئن هستید؟`}
                    showDeleteModal={modalState.mode === "device" && modalState.isOpen}
                    closeDeleteModal={closeModal}
                    RemoveItem={deleteDeviceCallback}
                    title="اخطار حذف اطلاعات"
                />
                <DeleteModal
                    text={`آیا برای اخراج “${modalState.selectedItem == null ? "" : modalState.selectedItem.serialNumber}” مطمئن هستید؟`}
                    showDeleteModal={modalState.mode === "broker" && modalState.isOpen}
                    closeDeleteModal={closeModal}
                    RemoveItem={deleteBrokerCallback}
                    title="اخطار اخراج از بروکر"
                />
            </div>

            <div
                className={"mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px "}>
                <TitleDetail title={"لیست تراکنش ها"} className={"mb-25"}/>

                <Table2
                    headers={ClientDetailTransactionHeaders}
                    tableData={transactionList}
                    operations={ListsOperations.getTransactionList(() => {

                    })}
                    emptyText={"تاریخچه‌ای یافت نشد"}
                    heightEmptyState={'h-66'}
                    pageNumber={1}
                    limit={10}
                    hasOperation={false}
                />

            </div>
        </div>
    )
}
export default ClientDetailScreen;